import React from "react";
import { useTranslation } from "react-i18next";
import "./HeroSection.css";

function HeroSection() {
  const { t } = useTranslation();

  return (
    <div className="hero-container">
      <video src="/videos/intro.mp4" autoPlay loop muted />
      <h1>{t("homepage.title")}</h1>
      <p>{t("homepage.section1_title")}</p>

      <div className="hero-btns">
        <a
          href="https://play.google.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="store-link"
          aria-label="Google Play Store"
        >
          <img
            src="/images/googlePlayLogo.png"
            alt="Google Play Store"
            className="store-badge"
          />
        </a>

        <a
          href="https://www.apple.com/app-store/"
          target="_blank"
          rel="noopener noreferrer"
          className="store-link"
          aria-label="Apple App Store"
        >
          <img
            src="/images/appStoreLogo.png"
            alt="Apple App Store"
            className="store-badge"
          />
        </a>
      </div>
    </div>
  );
}

export default HeroSection;
